var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 186,
    viewBox: "0 0 182 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "round-anime"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 8",
    d: "M57.0465 34.189C45.1892 40.6314 35.5562 50.5075 29.4112 62.5216C23.2663 74.5357 20.8963 88.1267 22.6124 101.512L26.5161 101.011C24.9009 88.4132 27.1315 75.6214 32.9151 64.3137C38.6988 53.0061 47.7654 43.7107 58.9254 37.6471L57.0465 34.189Z",
    fill: "#DA2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 9",
    d: "M140.386 135.886C148.198 126.526 153.306 115.208 155.156 103.157L151.266 102.56C149.524 113.903 144.718 124.554 137.364 133.365L140.386 135.886Z",
    fill: "#DA2128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundAnimation);
export default __webpack_public_path__ + "static/media/round-animation.dc75b1623a712675c571c89f54ddedcb.svg";
export { ForwardRef as ReactComponent };